import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import phone from 'assets/images/phone.svg';
import Button from '../../../components/common/Button';
import { close as closeModal } from '../../../modules/modal/actions';

export const PhoneAlreadyRegistered = ({ close }) => (
  <div className="modal phone-already-registered">
    <img src={phone} className="phone-already-registered__image" />
    <h2 className="phone-already-registered__header">
      Mobile Number Already Registered
    </h2>

    <p className="phone-already-registered__text">
      Enter a valid unregistered mobile number in order to complete the activation process
    </p>

    <Button
      className="modal__button"
      onClick={close}
    >
      Back
    </Button>
  </div>
);

PhoneAlreadyRegistered.propTypes = {
  close: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  close: closeModal
};

export default connect(null, mapDispatchToProps)(PhoneAlreadyRegistered);
